type Loading = Record<string, boolean>;
export type PassportLoadingSetter = (update: (previous: Loading) => Loading) => void;

// Host UI ownership only, not request ordering or an engine scope replacement.
// Old context cleanup can run after a new context claimed the same setter.
const owners = new WeakMap<PassportLoadingSetter, Map<string, object>>();

export function createPassportLoadingOwner(setter: PassportLoadingSetter | undefined, field: string) {
  const token = {};
  return {
    start() {
      if (!setter) return;
      let fields = owners.get(setter);
      if (!fields) {
        fields = new Map();
        owners.set(setter, fields);
      }
      fields.set(field, token);
      setter((previous) => ({ ...previous, [field]: true }));
    },
    clear() {
      setter?.((previous) => {
        // Check at updater execution, not scheduling: React may defer it until
        // after the newer context's request has claimed the shared store.
        if (owners.get(setter)?.get(field) !== token) return previous;
        if (!previous[field]) return previous;
        const next = { ...previous };
        delete next[field];
        return next;
      });
    },
  };
}